import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../locales/en/translation.json';
import frTranslation from '../locales/fr/translation.json';
import deTranslation from '../locales/de/translation.json';
import chTranslation from '../locales/ch/translation.json';

// Persist user-chosen language across visits via a long-lived cookie.
// Cookie is canonical; localStorage is kept as a fallback in case cookies
// are blocked (Safari ITP, embed iframes, etc.).
const COOKIE_KEY = 'okoyl_lang';
const STORAGE_KEY = 'okoyl_lang';
const COOKIE_DAYS = 365;
const SUPPORTED = ['fr', 'en', 'de', 'ch'];

const readCookie = (name) => {
  if (typeof document === 'undefined' || !document.cookie) return null;
  const prefix = `${name}=`;
  const found = document.cookie.split('; ').find(row => row.startsWith(prefix));
  return found ? decodeURIComponent(found.slice(prefix.length)) : null;
};

const writeCookie = (name, value, days = COOKIE_DAYS) => {
  if (typeof document === 'undefined') return;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

const readStorage = (key) => {
  try {
    return (typeof window !== 'undefined' && window.localStorage)
      ? window.localStorage.getItem(key)
      : null;
  } catch (_) { return null; }
};

const writeStorage = (key, value) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(key, value);
    }
  } catch (_) { /* ignore */ }
};

const initialLng = (() => {
  const fromCookie = readCookie(COOKIE_KEY);
  if (SUPPORTED.includes(fromCookie)) return fromCookie;
  const fromStorage = readStorage(STORAGE_KEY);
  if (SUPPORTED.includes(fromStorage)) {
    // Migrate the value back into a cookie so the canonical store is consistent.
    writeCookie(COOKIE_KEY, fromStorage);
    return fromStorage;
  }
  return 'fr';
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      fr: { translation: frTranslation },
      de: { translation: deTranslation },
      ch: { translation: chTranslation },
    },
    lng: initialLng,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

// Keep cookie + localStorage in sync on every change.
i18n.on('languageChanged', (lng) => {
  if (!SUPPORTED.includes(lng)) return;
  writeCookie(COOKIE_KEY, lng);
  writeStorage(STORAGE_KEY, lng);
});

export const changeLanguage = (lng) => {
  return i18n.changeLanguage(lng);
};

export default i18n;
